import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { MatTableDataSource, MatDialog, PageEvent, MatSnackBar } from '@angular/material';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { AppServiceService } from 'src/app/services/app-service.service';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { CreateRolComponent } from '../create-rol/create-rol.component';
import { GatewayService } from 'src/app/gateway.service';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
	selector: 'app-rol',
	templateUrl: './rol.component.html',
	styleUrls: ['./rol.component.scss']
})
export class RolComponent implements OnInit {
  private destroy$ = new Subject<void>();
	campanaColumns: string[] = ['IDROL', 'NOMBREROL', 'DESCRIPCION', 'ES_CONTRATA', 'USUARIOS', 'ACCION'];
	dataSource = new MatTableDataSource<any>();
	private subscription: Subscription;
	private subscriptioncreate: Subscription;
	FILTER; resultsLength = 0;
	pageSize = 10;
	idpais;
	roles: any[] = [];

	constructor(
		private router: Router,
		private spinner: NgxSpinnerService,
		private gateway: GatewayService,
		public pageTitle: ComponentPageTitle,
		public _appservice: AppServiceService,
		public _busqueda: BusquedaService,
		public _create: CreateService,
		private dialog: MatDialog,
		private localSave: LocalSaveService,
		private snackBar: MatSnackBar
	) { }

	ngOnInit() {
		const user = this.localSave.get('usuarioPGV');

		// Acepta tanto el idrol legacy (10 = admin de rol) como cualquier usuario
		// que tenga el permiso 'ROL' con permiso_ver=1 en su rol_permiso.
		const tienePermisoROL = !!(user && user.permisos && user.permisos.find(
			(p: any) => p.modulo === 'ROL' && p.permiso_ver === 1));
		if (!user || (user.idrol != 10 && !tienePermisoROL)) {
			this.router.navigate(['/home']);
			return;
		}

		this.idpais = this.localSave.get('pais') || 5;
		this.get();
		this.pageTitle.title = 'Roles y Permisos';
		this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				this.FILTER = res.filtro;
				this.filterLocal();
			});
		this.subscriptioncreate = this._create.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				this.createRol();
			});
	}

	// ============== FILTRO ==============
	filter = '';
	public keyDownFunction(event) {
		if (event.keyCode == 13) {
			this.filtrogeneral();
		} else if (event.keyCode == 8 && this.filter == '') {
			this.filtrogeneral();
		}
	}
	public filtrogeneral() {
		this._busqueda.notificarBusqueda({ filtro: this.filter });
	}

	get() {
		this.spinner.show();
		this.gateway.get('getrolespermisos', {})
		.then((result: any) => {
			this.roles = result.rows || [];
			this.filterLocal();
			this.spinner.hide();
		}).catch((e) => {
			this.spinner.hide();
		});
	}

	filterLocal() {
		let filtered = this.roles;
		if (this.FILTER && this.FILTER.trim() !== '') {
			const f = this.FILTER.toLowerCase();
			filtered = this.roles.filter(r =>
				(r.nombre && r.nombre.toLowerCase().indexOf(f) >= 0) ||
				(r.descripcion && r.descripcion.toLowerCase().indexOf(f) >= 0)
			);
		}
		this.dataSource.data = filtered;
		this.resultsLength = filtered.length;
	}

	ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
		if (this.subscription) this.subscription.unsubscribe();
		if (this.subscriptioncreate) this.subscriptioncreate.unsubscribe();
	}

	/**
	 * Helper para usar en el template: valida si el usuario actual tiene
	 * el permiso solicitado sobre el modulo 'ROL'.
	 * tipo: 'ver' | 'crear' | 'editar' | 'borrar'.
	 * Si el usuario es idrol legacy === 10, retorna true para cualquier tipo.
	 */
	tienePermiso(tipo: string = 'ver'): boolean {
		const user = this.localSave.get('usuarioPGV');
		if (!user) return false;
		if (user.idrol === 10) return true;
		const perm = (user.permisos || []).find((p: any) => p.modulo === 'ROL');
		if (!perm) return false;
		return perm['permiso_' + tipo] === 1;
	}

	createRol() {
		const dialogRef = this.dialog.open(CreateRolComponent, {
			maxWidth: '90vw',
			width: '850px',
			minHeight: '50vh',
			data: { operacion: 'Crear', rol: { idpais: this.idpais } },
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			this.get();
		});
	}

	edit(element) {
		if (element.es_protegido === 1) return;
		const dialogRef = this.dialog.open(CreateRolComponent, {
			maxWidth: '90vw',
			width: '850px',
			minHeight: '50vh',
			data: { operacion: 'Editar', rol: element },
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			this.get();
		});
	}

	delete(element) {
		if (element.es_protegido === 1) return;
		if (element.usuarios_activos > 0) {
			this.snackBar.open('No se puede eliminar, tiene ' + element.usuarios_activos + ' usuario(s) activo(s)', '', { duration: 4000 });
			return;
		}
		const dialogRef = this.dialog.open(ConfirmacionComponent, {
			disableClose: true,
			width: '300px',
			data: { operacion: 'deleterolpermisos', id: { idrol: element.idrol } }
		});

		dialogRef.afterClosed().subscribe(() => {
			this.get();
		});
	}

}
